export enum LearningPathNavEnum {
  GENERAL = "Général",
  TRAININGS = "Formations",
}

export enum LearningPathTabTypeEnum {
  GENERAL = "general",
  TRAININGS = "trainings",
}

export enum LearningPathAttendeesNavEnum {
  ATTENDEES = "Participants",
  TRAININGS = "Formations",
}

export enum LearningPathAttendeesTabTypeEnum {
  ATTENDEES = "attendees",
  TRAININGS = "trainings",
}

export enum LearningPathTrainingStatusEnum {
  ACTIVE = "active",
  CREATING_BOOKINGS = "creating_bookings",
  CHECKING_EXISTING_BOOKINGS = "checking_existing_bookings",
  ERROR = "error",
}

export enum UserSubscriptionStatusEnum {
  NOT_BOOKED = "not_booked",
  CREATING_BOOKING = "creating_booking",
  BOOKED = "booked",
  ERROR = "error",
}
